const initialState = {
    data: {
        id: "",
        email: "",
        password: "",
        hospital_name: "",
        address: "",
        currency: "",
        phone: "",
        status: "",
        last_update: "",
      },
};

const UserLogin = (state = initialState, action: { type: string; payload: any; }) => {
    switch (action.type) {
        case "LOGIN": {
            return { ...state, data: action.payload };
        }
        case "LOGOUT": {
            return { ...initialState };
        }
        default: return state;
    }
};
export default UserLogin;
